<template>
  <main>
    <PageIntro
      :heading="'Your <span>' +configStrings.productName + '</span>'"
      :body="'<p>Please check your email for the password verification link email. Click the link in that email and it will bring you back to this page where you will be able to be able to set your new password.</p>'" />
    <ResetPasswordForm />
    <FooterShout :type="'signin'"/>
  </main>
</template>

<script>
  import ResetPasswordForm from '@/components/ResetPasswordForm.vue'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      ResetPasswordForm,
      PageIntro,
      FooterShout
    }
  }
</script>